module.exports = __webpack_public_path__ + "images/questions/qa_resolved_ribbon_b2772bb9317476b3b7d6a3ee64d7b9c5.png";